package com.evoapps.evoshift.appcheck

import com.evoapps.evoshift.data.remote.AppCheckTokens
import com.evoapps.evoshift.observability.FirebaseAppJs
import kotlinx.coroutines.await

/**
 * Firebase App Check in monitoring mode on the web (SH-185, docs/app-check.md): reCAPTCHA
 * Enterprise (invisible, no challenge for the person). Firestore and Auth send the token on their
 * own; the callable functions and Storage get it through [AppCheckTokens]. Nothing is enforced.
 *
 * Off without a site key (`APP_CHECK_RECAPTCHA_SITE_KEY` at build time, WebBuild.APP_CHECK_SITE_KEY)
 * and against the emulators (main.kt never calls it with `?emulator`), so local runs and the web
 * smoke test make no request outside the emulators. The pages' Content-Security-Policy
 * (firebase.json) allows reCAPTCHA and the App Check endpoint.
 */
object WebAppCheck {
    private var installed = false

    fun install(siteKey: String) {
        if (installed || siteKey.isBlank()) return
        installed = true
        runCatching {
            val options: dynamic = js("({})")
            options.provider = ReCaptchaEnterpriseProvider(siteKey)
            options.isTokenAutoRefreshEnabled = true
            val appCheck = initializeAppCheck(FirebaseAppJs.getApp(), options)
            AppCheckTokens.provider = {
                val result: dynamic = getToken(appCheck, false).await()
                result?.token as? String
            }
        }.onFailure { console.warn("App Check not installed: ${it.message}") }
    }
}
